module.exports = __webpack_public_path__ + "assets/843c249b45e58a95e8f240aed378eaeb.png";